/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import './MobileCalculator.scss';
import Footer from '../navigation/Footer';
import CalculatorCardCollection from '../cards/CalculatorCardCollection';
import MainBanner from '../navigation/MainBanner';
import { CalculatorResult, ParameterModifier, ParameterName } from '../../../modules/calculator/calculatorTypes';
import MobileCalculatorHeader from './MobileCalculatorHeader';
import { handleScroll } from '../navigation/ScrollNav';
import { ScrollNavContext } from '../../context/ScrollNavContext';
import { ModalType } from '../modals/Modals';
import { OptionsConfig } from '../modals/OptionsModal';
import { UnitPreset } from '../../../modules/units/unitTypes';

interface Method {
  id: number;
  heading: string;
  subHeading: string;
  longDesc: string;
}

interface MobileCalculatorProps {
  activeMethod: number;
  onParameterChange: (cardIndex: number, parameterName: ParameterName, value: ParameterModifier, phase?: number) => void;
  currentResult?: CalculatorResult;
  theme: string;
  method: Method;
  setIsScrolled: (value: boolean) => void;
  openModal: (type: ModalType, title?: string, optionsConfig?: OptionsConfig, onAccept?: VoidFunction, onReject?: VoidFunction) => void;
  currentUnitPreset: UnitPreset | undefined;
  onReset: () => void;
}

const MobileCalculator = ({
  activeMethod,
  method,
  onParameterChange,
  currentResult,
  theme,
  setIsScrolled,
  openModal,
  currentUnitPreset,
  onReset,
}: MobileCalculatorProps) => {
  const [headerSize, setHeaderSize] = React.useState<number>(0);
  const [calculatorScrollPosition, setCalculatorScrollPosition] = React.useState<number>(0);
  const [, setActivePhase] = React.useContext(ScrollNavContext);

  return (
    <>
      <MobileCalculatorHeader
        activeMethod={activeMethod}
        method={method}
        calculatorScrollPosition={calculatorScrollPosition}
        theme={theme}
        setHeaderSize={setHeaderSize}
      />
      <div
        id="mobile-calculator"
        onScroll={(e: any) => {
          if (activeMethod > -1) {
            if (e.target.scrollTop > 200) {
              setIsScrolled(true);
            } else {
              setIsScrolled(false);
            }
            handleScroll(e, setActivePhase);
            setCalculatorScrollPosition(e.target.scrollTop);
          }
        }}
        className={`mobile-calculator ${activeMethod > -1 ? 'mobile-calculator--active' : ''} ${theme}`}
      >
        <div className="mobile-calculator__container" style={{ marginTop: headerSize ? headerSize : 0 }}>
          <CalculatorCardCollection
            onParameterChange={onParameterChange}
            currentResult={currentResult}
            activeMethod={activeMethod}
            openModal={openModal}
            currentUnitPreset={currentUnitPreset}
            theme={theme}
            onReset={onReset}
          />

          <div className="mobile-calculator__banner-wrap">
            <MainBanner variant="narrow" />
          </div>
          <div className="gtm-content gtm-content--mobile-calculator" />
          <Footer />
        </div>
      </div>
    </>
  );
};

export default MobileCalculator;
